import {
  useCurrentRefinements,
  useInstantSearch,
} from 'react-instantsearch-core';

import { generateDataTestId } from '@/lib/tests';

import { getSelectedFiltersCount } from './utils';

import * as S from './FiltersCounter.styles';

interface FiltersCounterProps {
  attribute: string;
}

export const FiltersCounter = ({ attribute }: FiltersCounterProps) => {
  const { items } = useCurrentRefinements();
  // useSearchBox will effect multi index query, can not use in searchView
  const query = useInstantSearch().indexUiState.query ?? '';

  const selectedFiltersCount = getSelectedFiltersCount(items, query, attribute);

  if (!selectedFiltersCount) {
    return null;
  }

  return (
    <S.FiltersCounter
      {...generateDataTestId('item', `${attribute}Counter`)}
      data-test-id='FiltersCounterItemCounter'
    >
      {selectedFiltersCount}
    </S.FiltersCounter>
  );
};

export const FiltersCounterForSearchView = ({
  attribute,
}: FiltersCounterProps) => {
  const { items } = useCurrentRefinements();

  const selectedFiltersCount = getSelectedFiltersCount(items, '', attribute);

  if (!selectedFiltersCount) {
    return null;
  }

  return (
    <S.FiltersCounter
      {...generateDataTestId('item', `${attribute}Counter`)}
      data-test-id='FiltersCounterForSearchViewItemCounter'
    >
      {selectedFiltersCount}
    </S.FiltersCounter>
  );
};
